import {
  fetchCategories,
  createCategory,
  updateCategory,
  deleteCategory,
} from "@/api/categories";
import { cloneDeep } from "lodash";

const getDefaultState = () => ({
  categories: [],
});

export const categories = {
  state: getDefaultState(),
  getters: {
    allCategories: (state) => cloneDeep(state.categories).reverse(),
  },
  mutations: {
    SET_CATEGORIES(state, categories) {
      state.categories = categories;
    },
    CREATE_CATEGORY(state, category) {
      state.categories.push(category);
    },
    UPDATE_CATEGORY(state, category) {
      const index = state.categories.findIndex((cat) => cat.id === category.id);
      if (index != -1) {
        state.categories.splice(index, 1, category);
      }
    },
    DELETE_CATEGORY(state, category) {
      const index = state.categories.findIndex((cat) => cat.id === category.id);
      if (index != -1) {
        state.categories.splice(index, 1);
      }
    },
    RESET_CATEGORIES(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async fetchCategories({ commit }) {
      try {
        const { data } = await fetchCategories();
        commit("SET_CATEGORIES", data);
        return data;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async createCategory({ commit }, payload) {
      try {
        const { data } = await createCategory(payload);
        commit("CREATE_CATEGORY", data);
        return data;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async updateCategory({ commit }, { id, ...payload }) {
      try {
        const { data } = await updateCategory(id, payload);
        commit("UPDATE_CATEGORY", data);
        return data;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async deleteCategory({ commit }, id) {
      try {
        const { data } = await deleteCategory(id);
        commit("DELETE_CATEGORY", { id, ...data });
        return data;
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
